import './index.scss';
import '../../../../css/global.css';
import '../../../../css/normalize.css';

import { useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import Cabecalho from '../../../../components/Cabecalho';
import Rodape from '../../../../components/Rodape';
import CookieAceite from '../../../../components/CookieAceite';
import BtnVoltar from '../../../../components/bntVoltar';
import MenuLateral from '../../../../components/MenuLateral';

import api from '../../../../api';

export default function EditarCategoria() {
    const [usuario_id, setIdUsuario] = useState(null);
    const [categorias, setCategorias] = useState([]);
    const [nome, setNome] = useState('');
    const [descricao, setDescricao] = useState('');
    const [idCategoriaPai, setIdCategoriaPai] = useState('');
    const navigate = useNavigate();
    const location = useLocation();
    const id_categoria = location.state?.id;

    const [idCategoriaParaExcluir, setIdCategoriaParaExcluir] = useState(null);

    /* Variáveis auxiliares */
    const [loading, setLoading] = useState(false);

    /* Dialog de exclusão de funcionário */
    const [modalAberto, setModalAberto] = useState(false);
    const caixaDeDialogo = useRef(null);

    useEffect(() => {
        caixaDeDialogo.current = document.getElementById("CaixaDeDialogo");
    }, []);

    const abrirModalExcluir = (id_categoria) => {
        setIdCategoriaParaExcluir(id_categoria);
        if (caixaDeDialogo.current) {
            caixaDeDialogo.current.showModal();
        }
    };

    const fecharModal = () => {
        setModalAberto(false);
        caixaDeDialogo.current?.close();
        setIdCategoriaParaExcluir(null);
    };

    const confirmarExcluirCategoria = async () => {
        try {
            await api.delete(`/categoria/${idCategoriaParaExcluir}`, {
                data: { usuario_id }
            });
            fecharModal();
            navigate('/menu/categoria');
        } catch (error) {
            fecharModal();
            setTexto(error.response?.data?.message || 'Erro ao excluir categoria.')
            abrirModalAviso();
        }
    };

    /* Dialog de avisos gerais */
    const CaixaDeDialogoAviso = useRef(null);
    const [modalAbertoAviso, setModalAbertoAviso] = useState(false);
    const [texto, setTexto] = useState("");

    useEffect(() => {
        CaixaDeDialogoAviso.current = document.getElementById("CaixaDeDialogoAviso");
    }, []);

    const abrirModalAviso = () => {
        if (CaixaDeDialogoAviso.current) {
            CaixaDeDialogoAviso.current.showModal();
        }
    };

    const fecharModalAviso = () => {
        setModalAbertoAviso(false);
        CaixaDeDialogoAviso.current?.close();
    };

    // Carrega os dados do usuário
    useEffect(() => {
        const buscarDadosUsuario = async () => {
            try {
                const response = await api.get('/usuario', { withCredentials: true });
                if (response.data.success) {
                    setIdUsuario(response.data.user.id);
                }
            } catch (error) {
                console.error('Erro ao buscar dados do usuário:', error);
            }
        };

        buscarDadosUsuario();
    }, []);

    // Carrega a lista de categorias
    useEffect(() => {
        const buscarCategorias = async () => {
            try {
                const response = await api.get('/categoriashierarquicas');
                if (response.data.success) {
                    setCategorias(response.data.categorias);
                } else {
                    console.error('Erro no backend:', response.data.message);
                }
            } catch (error) {
                console.error('Erro ao buscar categorias:', error);
            }
        };

        buscarCategorias();
    }, []);

    useEffect(() => {
        const carregarCategoria = async () => {
            try {
                const response = await api.get(`/categorias/${id_categoria}`);
                if (response.data.success) {
                    setNome(response.data.categoria.nome);
                    setDescricao(response.data.categoria.descricao);
                    setIdCategoriaPai(response.data.categoria.id_categoria_pai || '');
                } else {
                    console.error('Erro ao buscar categoria para edição');
                }
            } catch (error) {
                console.error('Erro ao buscar dados da categoria:', error);
            }
        };

        carregarCategoria();
    }, [id_categoria]);

    const enviarEditarCategoria = async (e) => {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setLoading(true);

        try {
            const response = await api.put(`/categorias/${id_categoria}`, {
                nome,
                descricao,
                id_categoria_pai: idCategoriaPai || null,
            });

            if (response.data.success) {
                navigate(`/menu/categorias`);
            }
        } catch (error) {
            console.error('Erro no envio do formulário de edição:', error);
        } finally {
            setLoading(false);
        }
    };

    const categoriasFiltradas = categorias.filter(categoria => categoria.id !== id_categoria);

    return (
        <section className="container-principal-editar-categoria">

            <dialog id="CaixaDeDialogo" className={modalAberto ? 'open' : ''}>
                <div className='conteudo-dialog'>
                    <div className="dialog-texto">
                        <p>Você deseja excluir esse categoria?</p>
                        <div className='bnts-decisao'>
                            <button className="bnt-sim" onClick={confirmarExcluirCategoria}>
                                Sim
                            </button>
                            <button className="bnt-nao" onClick={fecharModal}>
                                Não
                            </button>
                        </div>
                    </div>
                </div>
            </dialog>

            <dialog id='CaixaDeDialogoAviso' className={modalAbertoAviso ? 'open' : ''}>
                <div className='conteudo-dialog'>
                    <div className='dialog-texto'>
                        <p>{texto}</p>
                        <button id='botao' onClick={fecharModalAviso}>
                            Ok
                        </button>
                    </div>
                </div>
            </dialog>

            <Cabecalho />
            <CookieAceite />
            <main>
                <MenuLateral />
                <section className="conteudo-editar-categoria">
                    <div className="titulo-perfil">
                        <h1><span>Categorias</span> &gt; Edição de Categoria</h1>
                    </div>
                    <BtnVoltar />
                    {loading ? (
                        <div className='loading'>
                            <svg xmlns='http://www.w3.org/2000/svg' width='25' height='25' viewBox='0 0 24 24'>
                                <path fill='#131C46' d='M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z' opacity='0.25' />
                                <path fill='#131C46' d='M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z'>
                                    <animateTransform attributeName='transform' dur='0.75s' repeatCount='indefinite' type='rotate' values='0 12 12;360 12 12' />
                                </path>
                            </svg>
                            <h2>Salvando...</h2>
                        </div>
                    ) : (
                    <div className='perfil-editar-categoria'>
                        <h2>Edite os dados da categoria</h2>
                        <form className="form-editar-categoria" onSubmit={enviarEditarCategoria}>
                            <label>Nome da Categoria: <span className='span-obrigatorio'>*</span></label>
                            <div className='input-nome'>
                                <input
                                    type="text"
                                    value={nome}
                                    onChange={(e) => setNome(e.target.value)}
                                    maxLength={255}
                                    placeholder="Digite o nome da categoria"
                                    required
                                />
                            </div>

                            <label>Descrição (opcional):</label>
                            <div className='input-descricao'>
                                <textarea
                                    value={descricao}
                                    onChange={(e) => setDescricao(e.target.value)}
                                    maxLength={255}
                                    placeholder="Digite a descrição da categoria"
                                />
                            </div>

                            <label>Categoria Pai (opcional):</label>
                            <div className='input-categoriaPai'>
                                <select
                                    value={idCategoriaPai}
                                    onChange={(e) => setIdCategoriaPai(e.target.value)}
                                >
                                    <option value="">Categoria Raiz</option>
                                    {categoriasFiltradas.map((categoria) => (
                                        <option key={categoria.id} value={categoria.id}>
                                            {categoria.nome}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <button className='bnt-editar-categoria' type="submit">Salvar Alterações</button>
                        </form>
                    </div>
                    )}
                </section>
            </main>
            <Rodape />
        </section>
    );
}
